import React from "react";
import * as supplierService from "../../services/supplierService";
import { DataTable, act } from "../Proc/procUi";
import { PrimaryButton, formatDate, useLoad } from "../../components/ui";

// Invitations from buyers that were sent to this person's own email or mobile (a supplier that already has
// a login accepts from here; a new one used the link in the email). Only the company's main user can accept.
export default function Invitations({ canAccept, onAccepted }) {
  const { data, reload } = useLoad(() => supplierService.getInvitations(), []);
  const rows = data || [];
  if (!rows.length) return null;
  const accept = (r) =>
    act(() => supplierService.acceptInvitation({ invitation_id: r.id }), "You are now linked to this buyer").then((res) => {
      if (res) {
        reload();
        onAccepted && onAccepted();
      }
    });
  return (
    <div className="mb-4">
      <h6>Invitations waiting for you</h6>
      <DataTable
        minWidth={480}
        rows={rows}
        columns={[
          { label: "Buyer", render: (r) => <strong>{r.buyer_name}</strong> },
          { label: "Invited", render: (r) => formatDate(r.created_at) },
          { label: "Valid until", render: (r) => formatDate(r.expires_at) },
          { label: "", render: (r) => (canAccept ? <PrimaryButton onClick={() => accept(r)}>Accept</PrimaryButton> : <span style={{ fontSize: 12, color: "#6B7280" }}>Ask your main user to accept</span>) },
        ]}
      />
    </div>
  );
}
